/** Format problem execution limits for solver UI. */
export const formatExecutionLimitsLabel = (limits) => {
  if (!limits) return null;
  const cpu = limits.cpuTimeLimit ?? limits.cpuTimeSec;
  const wall = limits.wallTimeLimit ?? limits.wallTimeSec;
  const memMb =
    limits.memoryLimitMb ??
    (limits.memoryLimitKb != null ? Math.round(limits.memoryLimitKb / 1024) : null);

  if (cpu == null && wall == null && memMb == null) return null;

  const parts = [];
  if (cpu != null) parts.push(`${cpu}s CPU`);
  if (wall != null) parts.push(`${wall}s wall`);
  if (memMb != null) parts.push(`${memMb} MB`);
  return parts.join(' · ');
};

export const DEFAULT_LIMITS_DISPLAY = {
  easy: { cpuTimeLimit: 2, wallTimeLimit: 5, memoryLimitMb: 256 },
  medium: { cpuTimeLimit: 2, wallTimeLimit: 6, memoryLimitMb: 256 },
  hard: { cpuTimeLimit: 3, wallTimeLimit: 10, memoryLimitMb: 512 },
};

const hasCustomLimits = (limits) =>
  limits &&
  (limits.cpuTimeLimit != null ||
    limits.cpuTimeSec != null ||
    limits.wallTimeLimit != null ||
    limits.wallTimeSec != null ||
    limits.memoryLimitMb != null ||
    limits.memoryLimitKb != null);

export const resolveLimitsForDisplay = (problem) => {
  if (hasCustomLimits(problem?.executionLimits)) {
    return problem.executionLimits;
  }
  const d = String(problem?.difficulty || 'easy').toLowerCase();
  return DEFAULT_LIMITS_DISPLAY[d] || DEFAULT_LIMITS_DISPLAY.easy;
};
